export const WIDGET_PRIORITY = 0.5;

export default { WIDGET_PRIORITY };
